(function () {
  var style = document.createElement('style');
  style.textContent = `
    .product-form__input--pill { display: none !important; }
    .tubuai-swatches {
      display: flex;
      align-items: center;
      gap: 10px;
      margin: 8px 0 12px;
    }
    .tubuai-swatches__label {
      font-size: 13px;
      font-weight: 600;
      color: #0e1b4d;
      margin-right: 4px;
    }
    .tubuai-swatch {
      width: 28px;
      height: 28px;
      border-radius: 50%;
      border: 2px solid transparent;
      cursor: pointer;
      transition: border-color 0.2s, transform 0.15s;
      outline: none;
    }
    .tubuai-swatch:hover { transform: scale(1.1); }
    .tubuai-swatch.active {
      border-color: #0e1b4d;
      box-shadow: 0 0 0 2px #fff, 0 0 0 4px #0e1b4d;
    }
    .tubuai-swatch[data-color="Black"] { background-color: #1a1a1a; }
    .tubuai-swatch[data-color="Green"]  { background-color: #9fc4b0; }
    /* Colores que todavía no se venden: solo visuales, grises y sin acción */
    .tubuai-swatch--soon { cursor: not-allowed; opacity: .4; filter: grayscale(.45); box-shadow: inset 0 0 0 1px rgba(14,27,77,.2); pointer-events: none; }
    .tubuai-swatch--soon:hover { transform: none; }
    .tubuai-swatch[data-color="White"] { background-color: #f4f3ef; }
    .tubuai-swatch[data-color="Pink"]  { background-color: #f1c3cc; }
  `;
  document.head.appendChild(style);

  var swatchContainer = null;

  // Los packs (app Pumper Bundles) tienen su propio selector de color y es el que manda al carrito:
  // al tocar un círculo, se pone el mismo color en todos los selectores de los packs.
  function syncPacks(val) {
    var w = document.querySelector('#pumper_bundle_svelte');
    if (!w) return;
    var groups = Array.prototype.slice.call(w.querySelectorAll('.pumper_dropdown_group'));
    (function next(i) {
      if (i >= groups.length) return;
      var g = groups[i], cur = g.querySelector('.pumper_dropdown_value');
      if (cur && cur.textContent.trim() === val) return next(i + 1);
      var trigger = g.querySelector('.pumper_dropdown_trigger');
      if (!trigger) return next(i + 1);
      trigger.click();
      setTimeout(function () {
        var opts = g.querySelectorAll('.pumper_dropdown_option');
        for (var k = 0; k < opts.length; k++) { if (opts[k].textContent.trim() === val) { opts[k].click(); break; } }
        setTimeout(function () { next(i + 1); }, 60);
      }, 60);
    })(0);
  }

  function setActive(val) {
    if (!swatchContainer) return;
    swatchContainer.querySelectorAll('.tubuai-swatch').forEach(function(s) {
      s.classList.toggle('active', s.getAttribute('data-color') === val);
    });
  }

  function initSwatches() {
    var productInfo = document.querySelector('product-info');
    if (!productInfo) return;
    if (productInfo.querySelector('.tubuai-swatches')) return;

    var variantSelects = productInfo.querySelector('variant-selects');
    if (!variantSelects) return;

    var variantJson = productInfo.querySelector('[data-selected-variant]');
    if (!variantJson) return;
    var currentVariant;
    try { currentVariant = JSON.parse(variantJson.innerHTML); } catch(e) { return; }

    var options = ['Black', 'Green'];

    swatchContainer = document.createElement('div');
    swatchContainer.className = 'tubuai-swatches';
    swatchContainer.innerHTML = '<span class="tubuai-swatches__label">Colores:</span>';

    options.forEach(function(val) {
      var btn = document.createElement('button');
      btn.className = 'tubuai-swatch';
      btn.setAttribute('data-color', val);
      btn.setAttribute('title', val);
      btn.setAttribute('type', 'button');

      if (currentVariant && currentVariant.title && currentVariant.title.includes(val)) {
        btn.classList.add('active');
      }

      btn.addEventListener('click', function() {
        // Click el boton nativo
        var nativeButtons = variantSelects.querySelectorAll('.button, input[type="radio"]');
        nativeButtons.forEach(function(nb) {
          var nbVal = nb.value || nb.textContent.trim();
          if (nbVal === val) {
            if (nb.tagName === 'INPUT') {
              nb.checked = true;
              nb.dispatchEvent(new Event('change', { bubbles: true }));
            } else {
              nb.click();
            }
          }
        });
        // Actualizar activo inmediatamente
        setActive(val);
        // al cambiar de variante el bloque de packs se vuelve a dibujar: se reintenta un rato
        [0, 400, 1000, 2000].forEach(function (ms) { setTimeout(function () { syncPacks(val); }, ms); });
      });

      swatchContainer.appendChild(btn);
    });

    // Blanco y rosa: próximamente (no seleccionables)
    ['White', 'Pink'].forEach(function(val) {
      var dot = document.createElement('span');
      dot.className = 'tubuai-swatch tubuai-swatch--soon';
      dot.setAttribute('data-color', val);
      dot.setAttribute('title', 'Próximamente');
      dot.setAttribute('aria-hidden', 'true');
      swatchContainer.appendChild(dot);
    });
    var soonLabel = document.createElement('span');
    soonLabel.className = 'visually-hidden';
    soonLabel.textContent = 'Blanco y rosa: próximamente';
    swatchContainer.appendChild(soonLabel);

    variantSelects.parentNode.insertBefore(swatchContainer, variantSelects);

    // Escuchar cambios externos (PumpBundle) para mantener sincronizado
    var observer = new MutationObserver(function() {
      var vjEl = productInfo.querySelector('[data-selected-variant]');
      if (!vjEl) return;
      try {
        var vj = JSON.parse(vjEl.innerHTML);
        if (vj && vj.title) {
          options.forEach(function(val) {
            if (vj.title.includes(val)) setActive(val);
          });
        }
      } catch(e) {}
    });
    observer.observe(productInfo, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSwatches);
  } else {
    initSwatches();
  }
})();
